import { render, staticRenderFns } from "./OpenCoreCreditRequests.vue?vue&type=template&id=3b191d58"
import script from "./OpenCoreCreditRequests.ts?vue&type=script&lang=ts&external"
export * from "./OpenCoreCreditRequests.ts?vue&type=script&lang=ts&external"
import style0 from "./OpenCoreCreditRequests.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports